window.grecaptcha = undefined

// TODO: maybe delete this after delete all mty
export default () => {}
